export const menus = [
  {
    title: '市场研究',
    path: 'marketing',
    icon: 'icon-shichangdapan-line',
    activeIcon: 'icon-shichangdapan-fill',
    children: [
      { title: '大盘概览', path: '/marketing/overview' },
      { title: '行业分析', path: '/marketing/analysis' },
      { title: '细分市场', path: '/marketing/segment' },
    ],
  },
  {
    title: '创意选品',
    enShortTitle: 'Prod Comp',
    path: '/creative',
    icon: 'icon-VS-line',
    activeIcon: 'icon-VS-2-fill',
  },
  {
    title: '商品',
    path: 'products',
    icon: 'icon-xuanpinku',
    activeIcon: 'icon-shangpin-fill',
    children: [
      { title: '选品库', path: '/analysis/products' },
      { title: '热销商品榜', path: '/analysis/products/hotSale' },
      { title: '达人热推榜', path: '/analysis/products/hotPush' },
    ],
  },
  {
    title: '小店',
    path: 'shop',
    icon: 'icon-dianpu-line',
    activeIcon: 'icon-dianpu-fill',
    children: [
      { title: '小店库', path: '/analysis/shop' },
      { title: '热销小店榜', path: '/analysis/shop/hotSale' },
      { title: '全托管店榜', path: '/analysis/shop/hosting', isBrHide: true },
      { title: '达人合作榜', path: '/analysis/shop/bloggerInteract' },
    ],
  },
  {
    title: '达人',
    path: 'blogger',
    icon: 'icon-daren-line',
    activeIcon: 'icon-daren-fill',
    children: [
      { title: '达人库', path: '/analysis/blogger' },
      { title: '达人涨粉榜', path: '/analysis/blogger/increaseFans' },
      { title: '达人带货榜', path: '/analysis/blogger/ecommerce' },
    ],
  },
  {
    title: '视频',
    path: 'video',
    icon: 'icon-shipin-line',
    activeIcon: 'icon-shipin1',
    children: [
      { title: '视频库', path: '/analysis/video' },
    // { title: '热门视频榜'), path: '/analysis/video/hot') },
    // { title: '带货视频榜'), path: '/analysis/video/ecommerce') },
    ],
  },
  {
    title: '直播',
    path: 'live',
    icon: 'icon-zhibo',
    activeIcon: 'icon-zhibo-fill',
    children: [
      { title: '直播库', path: '/analysis/live' },
      { title: '直播带货榜', path: '/analysis/live/ecommerce' },
    ],
  },
  {
    title: '橱窗达人检测',
    path: '/tool/bloggers',
    icon: 'icon-jiance-line',
    activeIcon: 'icon-jiance-fill',
  },
  {
    title: '我的收藏',
    path: 'favourites',
    icon: 'icon-shoucang2',
    activeIcon: 'icon-shoucang-fill',
    children: [
      { title: '商品收藏', path: '/favourites/product' },
      { title: '小店收藏', path: '/favourites/shop' },
      { title: '达人收藏', path: '/favourites/blogger' },
      { title: '视频收藏', path: '/favourites/video' },
      { title: '直播收藏', path: '/favourites/live' },
    ],
  },
  // {
  //   title: '会员购买',
  //   path: '/vip',
  //   icon: 'icon-huiyuangoumai',
  // },
  {
    title: '个人中心',
    path: 'user',
    icon: 'icon-gerenzhongxin-line',
    activeIcon: 'icon-gerenzhongxin-fill',
    children: [
      { title: '个人信息', path: '/user/info' },
      { title: '成员管理', path: '/user/member', isBrHide: true },
      { title: '我的订单', path: '/user/order', isBrHide: true },
    ],
  },
]
